export const environment = {
  production: true,
  buildId: '3435622050422081',
  configFile: 'config.json',
};
